import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mapEntries'
})

export class MapEntriesPipe implements PipeTransform {
    public transform<K, V>(map: Map<K, V>): Array<{ key: K, value: V }> {
        return Array.from(map.entries())
            .map((entry: [K, V]) => ({key: entry[0], value: entry[1]}));
    }
}